import { CSSProperties, ReactNode } from 'react';
import { useReduxState } from 'hooks';

const ContentBox = ({
  children,
  size = 'medium',
  style,
  title,
  titleFont = 'inherit',
  titleStyle = {}
}: {
  children: ReactNode;
  size?: string;
  style?: CSSProperties;
  title?: string | ReactNode;
  titleFont?: string;
  titleStyle?: CSSProperties;
}) => {
  const { theme } = useReduxState();

  return (
    <div className="box" style={style}>
      {title ? (
        <div className="header">
          <div
            className="title"
            style={{
              fontFamily: titleFont,
              fontSize: {
                small: '1.5rem',
                medium: '1.6rem',
                large: '1.8rem',
                huge: '2.2rem'
              }[size],
              ...titleStyle
            }}
          >
            {title}
          </div>
        </div>
      ) : null}

      <div
        className="content"
        style={{
          fontSize: {
            small: '1.5rem',
            medium: '1.6rem',
            large: '1.8rem',
            huge: '2.2rem'
          }[size]
        }}
      >
        {children}
      </div>

      <style jsx>{`
        .box {
          background-color: ${theme.lightGrey};
          border-radius: ${theme.cardBorderRadius};
        }
        .header {
          background-color: ${theme.lightGreyDark};
          border-radius: ${`${theme.cardBorderRadius} ${theme.cardBorderRadius} 0 0`};
          padding: 10px 15px;
        }
        .title {
          color: ${theme.textColorLight};
          font-size: 1.5rem;
          font-weight: 700;
          line-height: 1.4;
          margin: 0;
        }
        .content {
          color: ${theme.textColorLight};
          font-size: 1.5rem;
          padding: 15px;
        }
      `}</style>
    </div>
  );
};

export default ContentBox;
